import SlimSelect from 'slim-select';

export default class OrderBy {

    async init(): Promise<void> {
        this.changeOrderbyPosition();
        this.orderBySlimSelect();
        jQuery(document).on('ajaxComplete', () => this.changeOrderbyPosition());
        jQuery(document).on('ajaxComplete', () => this.orderBySlimSelect());
    }

    async orderBySlimSelect(): Promise<void> {
        const sortSelect: HTMLSelectElement | null = document.querySelector('.woocommerce-ordering .orderby');

        if (sortSelect && document.querySelector('.woocommerce-ordering .orderby.ss-main') === null) {
            new SlimSelect({
                select: sortSelect,
                settings: {
                    showSearch: false,
                    searchHighlight: true,
                    openPosition: 'down'
                },
                events: {
                    afterChange: (info) => {
                        sortSelect.dispatchEvent(new CustomEvent('change', { bubbles: true }))
                    }
                }
            });
        }
    }
     async changeOrderbyPosition(): Promise<void> {
        const orderForm: HTMLSelectElement | null = document.querySelector(`${wcapf_params.shop_loop_container} .woocommerce-ordering`);
        const archiveOrderbyPlaceholder: HTMLElement | null = document.querySelector('.shop-wrapper .orderby-placeholder') as HTMLElement;

        if (orderForm && archiveOrderbyPlaceholder) {
            archiveOrderbyPlaceholder.innerHTML = '';
            archiveOrderbyPlaceholder.appendChild(orderForm);
            archiveOrderbyPlaceholder.querySelector('.woocommerce-ordering')?.classList.remove('hidden');
        }
    }
}